import * as React from "react";
const SvgSubtract = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 16H3V3H16V8H21V21H8V16ZM5 5H14V8H8V14H5V5Z", fill: "currentColor" }));
export default SvgSubtract;
